import {getPersianDateTime} from '../../../../utilities/helper/GetPersianDateTime';
import {ICashBackHistory} from '../api/getCashBackHistoryList/cashBackHistory.types';
import {
  getCashBackTransactionDescription,
  getCashBackTransactionPresentation,
} from '../helpers/cashBackTransactionHelpers';

interface TransactionItemCardProps {
  transaction: ICashBackHistory;
}

const TransactionItemCard = ({transaction}: TransactionItemCardProps) => {
  const presentation = getCashBackTransactionPresentation(
    transaction.transaction_type,
  );

  const description = getCashBackTransactionDescription(transaction);

  return (
    <div
      className={`relative rounded-lg px-6 py-2 ${presentation.containerClassName}`}
      dir="rtl"
    >
      <div className="flex items-center justify-between my-2">
        <div className="flex items-center gap-1.5 text-sm text-gray-600">
          <i className="text-lg icon-namemoney" />
          <span>{presentation.amountLabel}</span>
        </div>

        <div
          className={`flex items-center justify-center gap-1 ${presentation.amountClassName}`}
        >
          <span className="font-medium text-md">
            {transaction.amount.toLocaleString('fa-IR')}
          </span>
          <span className="text-sm">تومان</span>
        </div>
      </div>

      <div className="flex items-center justify-between my-2">
        <div className="flex items-center gap-1.5 text-sm text-gray-600">
          <i className="text-lg icon-nameCalendar" />
          <span>{presentation.dateLabel}</span>
        </div>

        <span className="text-sm text-gray-600">
          {getPersianDateTime(transaction.created_at)}
        </span>
      </div>

      <div className="flex items-start justify-between gap-3 my-2">
        <div className="flex items-center gap-1.5 text-sm text-gray-600 shrink-0">
          <i className="text-lg icon-namereport" />
          <span>توضیحات</span>
        </div>

        <span className="text-sm text-left text-gray-600">{description}</span>
      </div>
    </div>
  );
};

export default TransactionItemCard;
